import { Api } from '../api/models/apis';
import { AppDispatch } from '../app/store';
import { PollingState, addIntervalId, setIsPolling } from './pollingSlice';

export const taskExecutionPollingId = 'taskExecutionPolling';
export const ETLAssetPollingId = 'ETLAssetPolling';

const pollingMethodFactory = (api: Api, pollingId: string, params: any) => {
  switch (pollingId) {
    case taskExecutionPollingId:
      return api.task.fecthAndStoreTaskExecutions;
    case ETLAssetPollingId:
      if (params.assetId) {
        return () => api.asset.fetchAndStoreAsset(params.assetId);
      }
      return null;
    default:
      return null;
  }
};

export const updatePolling = (api: Api, dispatch: AppDispatch, pollingState: PollingState) => {
  const { isPolling, pollingConfigurations } = pollingState;
  if (!isPolling && pollingConfigurations.length > 0) {
    dispatch(setIsPolling(true));
    pollingConfigurations.forEach(async (config) => {
      const pollingMethod = pollingMethodFactory(api, config.identifier, config.params);
      if (!pollingMethod) return;
      const intervalId = setInterval(pollingMethod, config.interval);
      dispatch(addIntervalId({ identifier: config.identifier, intervalId: intervalId }));
    });
  } else if (pollingConfigurations.length > 0) {
    pollingConfigurations
      .filter((conf) => !conf.intervalId)
      .forEach(async (config) => {
        const pollingMethod = pollingMethodFactory(api, config.identifier, config.params);
        if (!pollingMethod) return;
        clearInterval(config.intervalId);
        const intervalId = setInterval(pollingMethod, config.interval);
        dispatch(addIntervalId({ identifier: config.identifier, intervalId: intervalId }));
      });
  }
};
